/** Application shell. */
import { useEffect } from 'preact/hooks';
import { dismiss, notices } from '../app/store';
import { offerRestore, startAutosave } from '../app/session';
import { installGlobalInput } from './globalInput';
import { PANELS } from './panelRegistry';
import { CalibrateDialog } from './panels/CalibrationPanel';
import { Toolbar } from './Toolbar';
import { Tooltip } from './Tooltip';
import { WindowManager } from './WindowManager';
import { Icon } from './icons';

function Notices() {
  return (
    <div class="notices" aria-live="polite" data-testid="notices">
      {notices.value.map((n) => (
        <div key={n.id} class={`notice ${n.kind}`} role={n.kind === 'error' ? 'alert' : 'status'}>
          <span class="notice-text">{n.text}</span>
          {n.action && (
            <button
              type="button"
              class="btn small primary"
              onClick={() => {
                n.action!.run();
                dismiss(n.id);
              }}
            >
              {n.action.label}
            </button>
          )}
          <button type="button" class="icon-btn" aria-label="Dismiss" onClick={() => dismiss(n.id)}>
            <Icon name="close" size={13} />
          </button>
        </div>
      ))}
    </div>
  );
}

export function App() {
  useEffect(() => {
    const off = installGlobalInput();
    offerRestore().finally(startAutosave);
    return off;
  }, []);
  return (
    <div class="app">
      <Toolbar />
      <WindowManager panels={PANELS} />
      <Notices />
      <Tooltip />
      <CalibrateDialog />
      <div class="drop-overlay">
        <div>Drop to load into image A (second file → B, .aperto → session)</div>
      </div>
    </div>
  );
}
